<div class="api-specification">
  <h2>Properties</h2>
  <div class="api-table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Property</th>
          <th>Type</th>
          <th>Default Value</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        @for (property of properties; track property.name) {
          <tr>
            <td>
              <code>{{ property.name }}</code>
            </td>
            <td>
              <code>{{ property.type }}</code>
            </td>
            <td>
              <code>{{ property.defaultValue || '-' }}</code>
            </td>
            <td>
              @if (property.syncAsync) {
                <code>{{ property.syncAsync }}</code>
                :
              }
              {{ property.description || '-' }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <h2>Events</h2>
  <div class="api-table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Event</th>
          <th>Type</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        @for (event of events; track event.name) {
          <tr>
            <td>
              <code>{{ event.name }}</code>
            </td>
            <td>
              <code>{{ event.type }}</code>
            </td>
            <td>
              @if (event.syncAsync) {
                <code>{{ event.syncAsync }}</code>
                :
              }
              {{ event.description || '-' }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <h2>CSS Custom Properties</h2>
  <div class="api-table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Css Custom Property</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        @for (customProperty of cssCustomProperties; track customProperty.property) {
          <tr>
            <td>
              <code>{{ customProperty.property }}</code>
            </td>
            <td>{{ customProperty.description }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
